export default __webpack_public_path__ + "static/media/Genomes.89889659.svg";